import styled from 'styled-components';

const TableContainer = styled.div`
.not-read {
  font-weight: bold;
}

`

export default TableContainer;